import { iesireDinMail } from '../lib/iesireMail'
import { create } from 'zustand'
import type { Permission, Role } from '@b4l/shared'

export interface AuthUser {
  id: number
  email: string
  name: string
  role: Role
  /** Funcția afișată. `role` rămâne termenul de sistem, care decide drepturile. */
  jobTitle?: string | null
  mustChangePassword: boolean
}

interface AuthState {
  accessToken: string | null
  user: AuthUser | null
  permissions: Permission[]
  initialized: boolean
  setAccessToken: (token: string | null) => void
  setSession: (token: string, user: AuthUser, permissions: Permission[]) => void
  setUser: (user: AuthUser, permissions: Permission[]) => void
  setInitialized: (v: boolean) => void
  clear: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  user: null,
  permissions: [],
  initialized: false,
  setAccessToken: (token) => set({ accessToken: token }),
  setSession: (token, user, permissions) =>
    set({ accessToken: token, user, permissions, initialized: true }),
  setUser: (user, permissions) => set({ user, permissions, initialized: true }),
  setInitialized: (v) => set({ initialized: v }),
  clear: () => {
    // Si sesiunea de mail, la orice iesire (logout, logare expirata). Vezi `lib/iesireMail`.
    iesireDinMail()
    set({ accessToken: null, user: null, permissions: [], initialized: true })
  },
}))

export function selectHasPermission(p: Permission): (s: AuthState) => boolean {
  return (s) => s.permissions.includes(p)
}
